module.exports = __webpack_public_path__ + "img/search-icon-input.0a1fe160.svg";